var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    !_vm.isProfile
      ? _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _vm._v(" " + _vm._s(_vm.T.omegaupTitleBadges) + " "),
            _c("span", { staticClass: "badge badge-secondary" }, [
              _vm._v(_vm._s(_vm.badges.length) + " ")
            ])
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.badges, function(badge, idx) {
            return _c("omegaup-badge", { key: idx, attrs: { badge: badge } })
          }),
          1
        )
      ])
    ]),
    _vm.showAllBadgesLink
      ? _c("div", { staticClass: "card-footer" }, [
          _vm.showAllBadgesLink
            ? _c(
                "a",
                { staticClass: "badges-link", attrs: { href: "/badge/list/" } },
                [_vm._v(_vm._s(_vm.T.wordsBadgesSeeAll))]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.badges,
            expression: "!badges"
          }
        ]
      },
      [_c("img", { attrs: { src: "/media/wait.gif" } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }